<div class="metric-breakdown" [dir]="languageService.direction()">
    <div class="modal-header">
        <h4 class="modal-title">{{ modalTitle() }}</h4>
        <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
    </div>

    @if (filters().length === 0) {
        <div class="modal-body">
            <div class="alert alert-warning my-1 border-0 rounded-1 fw-bold" role="alert">
                <i class="fa-solid fa-triangle-exclamation me-2" role="img" aria-label="Warning:"></i>
                {{ "metrics.no_breakdown_data" | translate }}
            </div>
        </div>
    } @else {
        <div class="breakdown-filters bg-card shadow">
            <div class="breakdown-filter">
                <adaa-form-dropdown
                    [setDefaultValue]="periodId()"
                    [label]="'common.tables.period' | translate"
                    [options]="periodsDdl()"
                    (inputChanges)="periodChanged($event)"
                />
            </div>
            @for (filter of filters(); track filter.dimensionId) {
                <div class="breakdown-filter">
                    <adaa-form-dropdown-multi
                        [label]="filter.dimensionName"
                        [options]="filter.options"
                        (inputChanges)="applyFilter($event, filter)"
                    />
                </div>
            }
        </div>

        <div class="modal-body breakdown-body">
            <div class="breakdown-grid">
                @for (chart of chartsConfig(); track chart.id) {
                    <section class="breakdown-card bg-card shadow" [class.full-column]="chart.isFullColumn">
                        <header class="breakdown-card-header">
                            <h5 class="breakdown-card-title">{{ chart.title }}</h5>
                            <span class="breakdown-card-meta">{{ chart.rows.length }} {{ "common.form.label.values" | translate }}</span>
                        </header>

                        <div class="breakdown-rows">
                            @for (row of chart.rows; track row.label) {
                                <div class="breakdown-label" [title]="row.label">{{ row.label }}</div>
                                <div class="breakdown-track">
                                    <div class="breakdown-bar" [style.width.%]="row.percentage" [style.background]="row.color"></div>
                                    <span class="breakdown-value">{{ row.valueText }}</span>
                                </div>
                            }
                        </div>

                        <div class="breakdown-axis">
                            <div></div>
                            <div class="breakdown-ticks">
                                @for (tick of chart.ticks; track $index) {
                                    <span>{{ tick }}</span>
                                }
                            </div>
                        </div>
                    </section>
                }
            </div>
        </div>
    }
</div>
